// Куда роль попадает после входа — ОДИН список на всё приложение.
//
// Он лежал в трёх файлах сразу: App.js, Login.js и ProductionBoard.js. Две
// копии из трёх указывали контролёра качества на «/quality-terminal», а
// такого маршрута нет и не было. Неизвестный адрес ловит path="*" и
// отправляет на вход — то есть контролёр входил в систему и тут же
// оказывался обратно на странице входа, без единого сообщения.
//
// Копии расходятся молча. Здесь один список; кто добавит роль — добавит её
// в одном месте, и все три экрана узнают об этом сразу.
const ROLE_HOME = {
  manager:    '/manager',
  technolog:  '/technolog',
  quality:    '/quality',
  operator:   '/terminal',
  sklad_gp:   '/warehouse',
  controller: '/sheet-terminal',
  director:   '/director',
  admin:      '/admin',
  buhgalter:  '/buhgalter',
  // Инвестор: свой экран — ИИ-помощник; полный дашборд директора ему закрыт.
  investor:   '/ai',
};

export default ROLE_HOME;
